import React, { useState } from 'react';
import UserTable from '../components/UserTable';
import UserForm from '../components/UserForm';
import styles from '../styles/Users.module.css';

const initialUsers = [
  { id: 101, name: 'John Doe', phone: '9876543210', email: 'john@example.com', role: 'Admin', status: 'Active' },
  { id: 201, name: 'Jane Smith', phone: '9123456780', email: 'jane@example.com', role: 'Editor', status: 'Inactive' },
  { id: 301, name: 'Alice Johnson', phone: '9988776655', email: 'alice@example.com', role: 'Viewer', status: 'Active' },
  { id: 401, name: 'Bob Lee', phone: '9001122334', email: 'bob@example.com', role: 'Editor', status: 'Active' },
  { id: 501, name: 'Charlie Brown', phone: '9876501234', email: 'charlie@example.com', role: 'Admin', status: 'Inactive' },
  { id: 601, name: 'Daisy Miller', phone: '9988001122', email: 'daisy@example.com', role: 'Viewer', status: 'Active' },
  { id: 701, name: 'Ethan Hunt', phone: '1234567890', email: 'ethan@example.com', role: 'Editor', status: 'Inactive' }
];

const Users = () => {
  const [search, setSearch] = useState('');
  const [users, setUsers] = useState(initialUsers);
  const [showModal, setShowModal] = useState(false);
  const [editUser, setEditUser] = useState(null);

  const filtered = users.filter(u =>
    u.name.toLowerCase().includes(search.toLowerCase()) ||
    u.email.toLowerCase().includes(search.toLowerCase())
  );

  const handleDelete = id => setUsers(users.filter(u => u.id !== id));
  const handleEdit = user => { setEditUser(user); setShowModal(true); };
  const handleAdd = () => { setEditUser(null); setShowModal(true); };
  const handleSave = user => {
    if (user.id && users.some(u => u.id === user.id)) {
      // Edit existing user
      setUsers(users.map(u => (u.id === user.id ? user : u)));
    } else {
      // Add new user
      setUsers([...users, { ...user, id: user.id || Date.now().toString() }]);
    }
    setShowModal(false);
  };

  return (
    <div style={{ background: '#f8fafc', minHeight: '100vh', padding: '2.5rem 0' }}>
      <div style={{ maxWidth: 1100, margin: '0 auto', background: '#fff', borderRadius: 16, boxShadow: '0 4px 24px 0 rgba(0,0,0,0.08)', padding: '2.5rem 2rem' }}>
        <h2 style={{ color: 'black', textAlign: 'left', fontWeight: 700, marginBottom: '2.5rem', fontSize: '2.1rem', letterSpacing: '0.5px' }}>Users</h2>
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 18 }}>
          <input
            className={styles.searchInput}
            type="text"
            placeholder="Search by name or email..."
            value={search}
            onChange={e => setSearch(e.target.value)}
            style={{ width: 260 }}
          />
        </div>
        <UserTable
          users={filtered}
          onEdit={handleEdit}
          onDelete={handleDelete}
          onAdd={handleAdd}
        />
      </div>
      {showModal && (
        <div className={styles.modalOverlay}>
          <div className={styles.modalContent}>
            <UserForm
              user={editUser}
              onClose={() => setShowModal(false)}
              onSave={handleSave}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Users;